/* eslint-disable no-lone-blocks */
import React from "react";
import PrimaryButton from "../../Buttons/PrimaryButton";
import TertiaryButton from "../../Buttons/TertiaryButton";
import Dropdown from "../../Dropdown/Dropdown";
import useAddAttributesPopup from "./useAddAttributesPopup";
import PopupHeader from "../PopupHeader";
import { SelectedAttributes, NewAttributes } from "./attributeHelpers";

const AddAttributePopup = ({ popupData, closePopup }) => {
  const {
    formatOptionsForDDL,
    attributes,
    resourceAttributes,
    // selected attributes from the current options
    selectedAttributes,
    // select/remove/change/validation from temporary list of attributes to send to resource
    handleSelectAttribute,
    handleRemoveAttribute,
    handleChangeSelectedAttribute,
    canAddAttributes,
    // Create New section, onChange, state, clear, validation
    onAddNewAttribute,
    onChangeAttribute,
    newAttributes,
    handleClearNewEntry,
    isValidNewAttribute,
    isDuplicate,
    // utility, main cancel & onFinish
    isAdminPage,
    handleCancel,
    onFinish,
    attributesLoading,
  } = useAddAttributesPopup({ popupData, closePopup });
  return (
    <div className="h-full w-full">
      <PopupHeader headerTitle="Add Attributes" closePopup={closePopup} />
      <div
        className={
          attributesLoading ? "loading relative" : "flex flex-col gap-8 p-6"
        }
      >
        {/* Container */}
        <div className="flex flex-row gap-8">
          {!isAdminPage && ( // isAdminPage only shows `Add New`
            <div>
              <div className="flex flex-row justify-between pb-4 items-center">
                <p className="text-es-medium-grey font-es-bold text-es-normal">
                  Choose Existing
                </p>
              </div>
              <div
                style={{
                  width: "500px",
                  height: "400px",
                }}
              >
                <div className="flex flex-col gap-6 justify-start p-6 mb-6 border border-es-light-grey rounded-xl h-full">
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-es-normal text-es-medium-grey font-es-semibold">
                      Type
                    </p>
                    <Dropdown
                      key="Add Existing Attribute"
                      className="w-full"
                      placeholder="Select"
                      options={formatOptionsForDDL(
                        attributes,
                        resourceAttributes,
                        selectedAttributes
                      )}
                      value=""
                      onChange={handleSelectAttribute}
                      disableClear
                      tooltipDataWrapperClassName="mb-2"
                    />
                  </div>
                  <SelectedAttributes
                    selectedElements={selectedAttributes}
                    handleRemoveElement={handleRemoveAttribute}
                    handleChange={handleChangeSelectedAttribute}
                  />
                </div>
              </div>
            </div>
          )}
          <div>
            <div className="flex flex-row justify-between pb-4 items-center">
              <p className="text-es-medium-grey font-es-bold text-es-normal">
                {!isAdminPage ? "Or Add New" : "Add New Attributes"}
              </p>
            </div>
            <div
              style={{
                width: "404px",
                height: "400px",
              }}
            >
              <div className="flex flex-col gap-6 justify-start p-6 mb-6 border border-es-light-grey rounded-xl h-full">
                <div className="flex flex-col gap-2">
                  <NewAttributes
                    newAttributes={newAttributes}
                    onChangeAttribute={onChangeAttribute}
                    isDuplicate={isDuplicate}
                  />
                </div>
                <div className="flex flex-row items-center gap-3 bottom-0">
                  <PrimaryButton
                    onClick={() => onAddNewAttribute()}
                    saveButtonTitle="Add"
                    saveButton
                    disabled={!isValidNewAttribute()}
                  />
                  <TertiaryButton
                    onClick={() => handleClearNewEntry()}
                    cancelButtonTitle="Clear"
                    cancelButton
                  />
                </div>
              </div>
            </div>
            {isAdminPage && (
              <div className="flex flex-row items-center justify-end mt-4">
                <TertiaryButton
                  onClick={() => handleCancel()}
                  title="Close"
                  className="border border-es-green p-2 text-es-green hover:text-es-white"
                />
              </div>
            )}
          </div>
        </div>
        {!isAdminPage && (
          <div className="flex flex-row items-center gap-3 bottom-0">
            <PrimaryButton
              onClick={() => onFinish()}
              saveButtonTitle="Save"
              saveButton
              disabled={!canAddAttributes()}
            />
            <TertiaryButton
              onClick={() => handleCancel()}
              cancelButtonTitle="Close"
              cancelButton
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AddAttributePopup;
